import { Trash2, Plus } from 'lucide-react'
import { Button, Input } from '@/components/ui'
import { blankCustomerOrderLine } from '../api/types'
import type { BolCustomerOrderLine } from '../api/types'

interface Props {
  lines: BolCustomerOrderLine[]
  onChange: (lines: BolCustomerOrderLine[]) => void
}

export function CustomerOrderLinesEditor({ lines, onChange }: Props) {
  const rows = lines.length > 0 ? lines : [blankCustomerOrderLine()]

  function update(idx: number, field: keyof BolCustomerOrderLine, value: string) {
    onChange(rows.map((line, i) => (i === idx ? { ...line, [field]: value } : line)))
  }

  function addRow() {
    onChange([...rows, blankCustomerOrderLine()])
  }

  function removeRow(idx: number) {
    onChange(rows.length === 1 ? [blankCustomerOrderLine()] : rows.filter((_, i) => i !== idx))
  }

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-[2fr_1fr_1fr_1fr_36px] gap-2 px-1">
        {['Customer Order #', 'Qty', 'Weight', 'Pallet/Slip (Y/N)', ''].map((h) => (
          <span key={h} className="text-xs font-medium text-secondary uppercase tracking-wide">{h}</span>
        ))}
      </div>
      {rows.map((line, idx) => (
        <div key={idx} className="grid grid-cols-[2fr_1fr_1fr_1fr_36px] gap-2 items-start">
          <Input value={line.order_number} onChange={(e) => update(idx, 'order_number', e.target.value)} placeholder="PO #" />
          <Input value={line.qty} onChange={(e) => update(idx, 'qty', e.target.value)} placeholder="Qty" />
          <Input value={line.weight} onChange={(e) => update(idx, 'weight', e.target.value)} placeholder="Weight" />
          <Input value={line.pallet_slip} onChange={(e) => update(idx, 'pallet_slip', e.target.value)} placeholder="Y/N" />
          <button type="button" onClick={() => removeRow(idx)} className="h-8 w-8 flex items-center justify-center rounded text-secondary hover:text-danger hover:bg-danger/10 transition-colors" title="Remove line">
            <Trash2 size={14} />
          </button>
        </div>
      ))}
      <Button variant="ghost" size="sm" onClick={addRow} className="mt-1">
        <Plus size={14} className="mr-1" /> Add line
      </Button>
    </div>
  )
}
